import { render, staticRenderFns } from "./MaintenanceScreen.vue?vue&type=template&id=a66499c0&scoped=true"
import script from "./MaintenanceScreen.vue?vue&type=script&lang=js"
export * from "./MaintenanceScreen.vue?vue&type=script&lang=js"
import style0 from "./MaintenanceScreen.vue?vue&type=style&index=0&id=a66499c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66499c0",
  null
  
)

export default component.exports